import { useState } from 'react';

import { FormHelperText, OutlinedInput, useFormControl } from '@mui/material';
import { useIntl } from 'react-intl';

import { MAX_CHARACTERS } from '../constants';

interface MultilineInputProps {
  value: string;
  onChange: (newValue: string) => void;
  placeholderKey: string;
  error: boolean;
}

const MultilineInput = ({
  value,
  onChange,
  placeholderKey,
  error,
}: MultilineInputProps) => {
  const { formatMessage } = useIntl();
  const { focused } = useFormControl() || {};
  const [touched, setTouched] = useState(false);
  const hasError = touched && error;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const newValue = e.target.value;
    if (newValue.length > MAX_CHARACTERS) {
      return;
    }
    onChange(newValue);
  };

  return (
    <>
      <OutlinedInput
        multiline
        rows={3}
        required
        value={value}
        onChange={handleChange}
        placeholder={formatMessage({ id: placeholderKey })}
        error={touched && error}
        onBlur={() => setTouched(true)}
        sx={{ borderRadius: '8px' }}
      />
      {focused && (
        <FormHelperText error={hasError}>
          {formatMessage({ id: 'CPPLATFORM.CRITICALPATIENT.CHARACTERSLIMIT' })}
          {` ${value.length}/${MAX_CHARACTERS}`}
        </FormHelperText>
      )}
    </>
  );
};

export default MultilineInput;
